export default __webpack_public_path__ + "static/media/imgloginteacher.04d282f2.svg";